export const addZeroToStart = (value = '', characters = 2) => `0${value}`.slice(-characters);

export const deepFind = ({ items, childrenKey, sourceKey, source }) => {
    let result = null;
    let item = null;

    if (!Array.isArray(items)) {
        return;
    }

    for (let i = 0, len = items.length; i < len; i++) {
        item = items[i];

        if (item[sourceKey] === source) {
            return item;
        }

        if (item[childrenKey]) {
            result = deepFind({
                items: item[childrenKey],
                childrenKey,
                sourceKey,
                source
            });
        }

        if (result) {
            return result;
        }
    }
};

export const recursiveCopy = ({ items = [], childrenKey, sourceKey, checkFn }) => {
    let data = {};

    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const itemChildren = item[childrenKey];

        if (checkFn) {
            if (checkFn(item)) {
                data[item[sourceKey]] = item;
            }
        } else {
            data[item[sourceKey]] = item;
        }

        if (itemChildren) {
            data = {
                ...data,
                ...recursiveCopy({ items: itemChildren, childrenKey, sourceKey, checkFn })
            };
        }
    }

    return data;
};

export const reverseString = (str) => str
    .split('')
    .reverse()
    .join('');
